import PropTypes from 'prop-types'
import useAuthority from 'utils/hooks/useAuthority'

const AuthorityCheck = (props) => {
    const {
        userAuthority = [],
        authority = [],
        children,
        userRole = [],
        roles = [],
    } = props

    const hasPermission = useAuthority(userAuthority, authority)
    const hasRole = useAuthority(userRole, roles)

    return hasPermission && hasRole ? children : null
}

AuthorityCheck.propTypes = {
    userAuthority: PropTypes.array,
    authority: PropTypes.array,
    userRole: PropTypes.array,
    roles: PropTypes.array,
}

export default AuthorityCheck
